import { Component,OnInit, Output, ElementRef, EventEmitter, Input } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import{SystemxService } from 'src/app/services/systemx.service';
import { FacilityService ,MessageService } from 'src/app/services';
import { AccessUserInfo, UserDetail, UserLocationFacility } from 'src/app/models';


@Component({
  selector: 'bart-locationcombosearch',
  templateUrl: './locationcombosearch.component.html',
  styleUrls: ['./locationcombosearch.component.scss']
})
export class LocationcombosearchComponent implements OnInit {
  loading = false;
  @Input() setComboLabel:string;
  @Input() selectedFacility: string;
  @Output() btnLocationCmoboClicked = new EventEmitter(); 
   
  userDetail :UserDetail  =null;

  public userFacilities: SelectItem[];
  public userLocations: SelectItem[]; 
  getSystemXDashboardParam = {
    divisionMasterId : 78,
    regionMasterId: 477,
    facilityMasterId: 82
    
  };
  getLocationParam = {
    locationIdList : 78,
    userName: 477, 
    
  };

  GETUSERLOCATIONS2 = {    
    USERNAME : AccessUserInfo.getUserInfo().userName
  }
  GETUSERFACILITIES = {    
    USERNAME: AccessUserInfo.getUserInfo().userName,
    LOCATION_ID_LIST: null
}


  constructor(private _FacilityService: FacilityService, private _SystemxService: SystemxService,private _messageService:MessageService) { 
   

    }

  ngOnInit() {    
    // this.userFacilities = [];
    // for (let i = 0; i < 10000; i++) {
    //     this.userFacilities.push({label: 'Item ' + i, value: 'ItemNumber ' + i});
    // }
    this.userDetail=AccessUserInfo.getUserInfo()
    this.GetUserLocations();
  }
  public getUserFacility()
  {
    if(this.selectedFacility!=null && this.selectedFacility!=undefined)
    {
     this.btnLocationCmoboClicked.emit(this.selectedFacility);
    }
    else
    {
      this._messageService.showAlertMessage("Please select a location.")
    }
  }
  GetUserFacilities() {
    if (this.getLocationParam != null) {
      // this._SystemXDashboardService.GetUserLocations(this.getLocationParam)
      // .subscribe((allUserLocationsResponse: any) => {
      //   //this.userLocations = allUserLocationsResponse.response;
      //   if(allUserLocationsResponse.response.userFacilities.length> 0)
      //   this.userLocations = [];
      //   for (let c of allUserLocationsResponse.response.userFacilities) {
      //     this.userLocations.push({ label: c.facilityDisplayName, value:c.facilityMasterID});;
      //   }
        
      //   }, (error) => {
      //     this.userFacilities = [];
      //     console.log(error)
      //     // handle error here
      //   }
      // );
    }
    
  }

  GetUserLocations() {
    this.loading = true;
    this._FacilityService.getUserLocationFacilities(this.userDetail.userName,(facilities:UserLocationFacility[])=>
    {
      this.userFacilities = [];
      if(facilities)
      {
        let userFacilitiesResp = facilities
        for (let c of userFacilitiesResp) {
          this.userFacilities.push({ label: c.FacilityDisplayName, value:c.FacilityMasterID});;
        }
      }
      this.loading = false;
    });
  }


  public GetSystemxDetails() {
    if (this.getSystemXDashboardParam != null) {
      
      this.userFacilities  =  this._SystemxService.GetLocationList(this.getSystemXDashboardParam);
      // .subscribe((allSystemXDetailResponse: Array<SystemXDetailResponse>) => {
      //     this.data = allSystemXDetailResponse['response'];
      //     this.dataSource = this.data;
      //     this.totalRecords = this.data.length;
      //   }, (respose: Response) => {
      //     this.data = [];
      //     // handle error here
      //   }
      // );
    }
  }

}
